import { forwardRef } from 'react';
import { OutlinedInput } from '@mui/material/';

const phoneInput = (props, ref) => {
  return (
    <OutlinedInput
      type="tel"
      fullWidth
      size="small"
      placeholder="Mobile"
      {...props}
      inputRef={ref}
    />
  );
};

export default forwardRef(phoneInput);
